import * as React from 'react';

import styles from './index.module.css';
import defaultStyles from '../../styles/formSetStyles.module.css';

import { SelectInput } from '../SelectInput';

interface Props {
  saveFieldValue: (value: string) => void;
  updateFieldValue: (value: string) => void;
  value: string;
}

interface State {
  amount: string;
  option: string;
}

export const maybeGetConvertedValues = (
  amount: number,
  option: string,
): { amount: string; option: string } | undefined => {
  if (isNaN(amount) || option === 'years') {
    return;
  }
  if (option === 'days' && amount < 30) return;
  if (option === 'weeks' && amount < 12) return;
  if (option === 'months' && amount < 24) return;

  let days = amount;
  if (option === 'weeks') days *= 7;
  else if (option === 'months') days *= 30;

  if (days >= 30 && days < 90) {
    return { amount: Math.round(days / 7).toString(), option: 'weeks' };
  } else if (days >= 90 && days < 720) {
    return { amount: Math.round(days / 30).toString(), option: 'months' };
  } else if (days >= 720) {
    return { amount: Math.round(days / 365).toString(), option: 'years' };
  }
};

export class RelativeDate extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    const [amount, option] = props.value.split(' ');

    this.state = {
      amount: amount || '',
      option:
        (['days', 'months', 'years'].includes(option) && option) || 'days',
    };
  }

  saveField = () => {
    const { saveFieldValue, updateFieldValue } = this.props;
    const { amount, option } = this.state;

    const converted = maybeGetConvertedValues(+amount, option);
    let newValue: string;
    if (converted) {
      this.setState({ amount: converted.amount, option: converted.option });
      newValue = [converted.amount, converted.option].join(' ');
    } else {
      newValue = amount && option ? [amount, option].join(' ') : '';
    }
    updateFieldValue(newValue);
    saveFieldValue(newValue);
  };

  handleInputChange = ({
    currentTarget,
  }: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({ amount: currentTarget.value });
  };

  handleSelectChange = (option: string) => {
    this.setState({ option }, this.saveField);
  };

  render() {
    const { amount, option } = this.state;
    const options = [
      { key: 'days', value: 'days', display: 'Days' },
      { key: 'weeks', value: 'weeks', display: 'Weeks' },
      { key: 'months', value: 'months', display: 'Months' },
      { key: 'years', value: 'years', display: 'Years' },
    ];

    return (
      <div
        className={[styles.RelativeDate, defaultStyles.InputWrapper].join(' ')}
      >
        <input
          className={[styles.Input, defaultStyles.Input].join(' ')}
          onBlur={this.saveField}
          onChange={this.handleInputChange}
          min={0}
          pattern="[0-9]*"
          step={1}
          type="number"
          value={amount}
        />
        <SelectInput
          onChange={this.handleSelectChange}
          options={options}
          value={option}
        />
      </div>
    );
  }
}
